import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-off-white">
      <Navbar />
      <main className="pt-24 min-h-screen pb-6">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
